// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oXBzH2uXm8dOkJawndaa{text-decoration:none;line-height:normal;width:137px}`, "",{"version":3,"sources":["webpack://./src/pages/broadcasts/ui/BroacastList/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA,CACA,kBAAA,CACA,WAAA","sourcesContent":[".helpButton {\n  text-decoration: none;\n  line-height: normal;\n  width: 137px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpButton": `oXBzH2uXm8dOkJawndaa`
};
export default ___CSS_LOADER_EXPORT___;
